<script>
	import {game, user} from "../client.svelte.js";
</script>


<!-------------------------------- HTML -------------------------------------->

<article>
	<iframe src='https://app.pentelion.de:90/p/{game.ID.replace("#", "")}?showChat=false&showLineNumbers=false&userName={user.ID}' width=600 height=400></iframe>
</article>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	iframe
		width: 72%
		height: calc(100% - 12px)

</style>